import { SelectInputData } from "../../../../../components/deprecated/SelectInputField/SelectInputField";
import { DataTypeData, DataTypeOption } from "../../../Company/DataTypeData";
import { GlobalDataTypeData } from "../../../Company/GlobalDataTypeData";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { InputElementContext } from "../DataObjectField";
import { FirebaseDataSelectField, FirebaseDataSelectFieldOption } from "../Generic/FirebaseDataSelectField";

export class FirebaseDataCustomDataTypeFields<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<
  DataTypeOption,
  FirebaseDataType
> {
  dataType: DataTypeData;
  constructor(
    dataType: DataTypeData,
    key: string,
    title: string,
    dataGetter: (data: FirebaseDataType) => DataTypeOption | DataTypeOption[] | undefined,
    iconName?: string,
    isArray: boolean = false
  ) {
    super(key, title, dataGetter, iconName, isArray);
    this.dataType = dataType;
  }

  encode = (value: DataTypeOption) => value.key;

  override convertValueToSelectInput(value: DataTypeOption): SelectInputData {
    return new SelectInputData(value.key + "", value.name.translate());
  }
  override getValueForKey(key: string): DataTypeOption | undefined {
    return this.dataType?.options.find((option) => option.key === key);
  }
  override getOptions(): FirebaseDataSelectFieldOption[] {
    return this.dataType?.options.map((data) => ({ key: data.key, label: data.name.translate() })) ?? [];
  }
  override getReadableStringRepresentation(value: DataTypeOption): string {
    return value.name.translate();
  }

  override loadAllDatas(context?: InputElementContext | undefined): Promise<void> {
    if (this.dataType && !this.dataType.loaded) {
      return this.dataType.load().then(() => {});
    }
    return Promise.resolve();
  }

  override loadData(value: DataTypeOption): Promise<any> {
    return this.dataType.load();
  }

  override loadRawData(value: any): Promise<any> {
    return this.dataType.load();
  }

  override isValueValid = (value: any) => {
    return typeof value === "object" && value !== null && value.key !== undefined && value.name !== undefined;
  };
}

export class FirebaseDataGlobalDataTypeFields<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<
  DataTypeOption,
  FirebaseDataType
> {
  dataType: GlobalDataTypeData;
  constructor(
    dataType: GlobalDataTypeData,
    key: string,
    title: string,
    dataGetter: (data: FirebaseDataType) => DataTypeOption | DataTypeOption[] | undefined,
    iconName?: string
  ) {
    super(key, title, dataGetter, iconName, false);
    this.dataType = dataType;
  }

  encode = (value: DataTypeOption) => value.key;

  override convertValueToSelectInput(value: DataTypeOption): SelectInputData {
    return new SelectInputData(value.key + "", value.name.translate());
  }
  override getValueForKey(key: string): DataTypeOption | undefined {
    return this.dataType?.options.find((option) => option.key === key);
  }
  override getOptions(): FirebaseDataSelectFieldOption[] {
    return this.dataType?.options.map((data) => ({ key: data.key, label: data.name.translate() })) ?? [];
  }
  override getReadableStringRepresentation(value: DataTypeOption): string {
    return value.name.translate();
  }

  override loadAllDatas(): Promise<any> {
    if (this.dataType && !this.dataType.loaded) {
      return this.dataType.load();
    }
    return Promise.resolve();
  }

  override isValueValid = (value: any) => {
    return typeof value === "object" && value !== null && value.key !== undefined && value.name !== undefined;
  };
}
